export const validatePassword = password => {
  const check_num = /[0-9]/; // 숫자
  const check_eng = /[a-zA-Z]/; // 문자
  const check_spc = /[~!@#$%^&*()_+|<>?:{}\[\]\\;'",./=`-]/; // 특수문자

  if (!check_num.test(password) || !check_eng.test(password) || !check_spc.test(password)) {
    return false;
  }

  return true;
};

export const handleChange = (event, form, setForm, setMessages, t) => {
  const { name, value } = event.target;
  setForm(prevForm => ({
    ...prevForm,
    [name]: value,
  }));

  // 새로운 비밀번호 검증
  if (name === 'newPassword') {
    if (value === '') {
      setMessages(prevMessages => ({
        ...prevMessages,
        newPassword: {
          text: t('newPasswordInputInfo1'),
          status: 'error',
        },
      }));
    } else if (value === form.password) {
      setMessages(prevMessages => ({
        ...prevMessages,
        newPassword: {
          text: t('newPasswordInputInfo5'),
          status: 'error',
        },
      }));
    } else if (validatePassword(value)) {
      setMessages(prevMessages => ({
        ...prevMessages,
        newPassword: {
          text: t('newPasswordInputInfo4'),
          status: 'success',
        },
      }));
    } else {
      setMessages(prevMessages => ({
        ...prevMessages,
        newPassword: {
          text: t('newPasswordInputInfo2'),
          status: 'error',
        },
      }));
    }

    // 비밀번호 확인 메시지 업데이트
    if (form.confirmPassword) {
      if (value === form.confirmPassword) {
        setMessages(prevMessages => ({
          ...prevMessages,
          confirmPassword: {
            //양호
            text: t('confirmPasswordInputInfo4'),
            status: 'success',
          },
        }));
      } else {
        setMessages(prevMessages => ({
          ...prevMessages,
          confirmPassword: {
            text: t('confirmPasswordInputInfo3'),
            status: 'error',
          },
        }));
      }
    }
  }

  // 비밀번호 확인 검증
  if (name === 'confirmPassword') {
    if (value === '') {
      setMessages(prevMessages => ({
        ...prevMessages,
        confirmPassword: {
          text: t('confirmPasswordInputInfo1'),
          status: 'error',
        },
      }));
    } else if (value === form.newPassword) {
      setMessages(prevMessages => ({
        ...prevMessages,
        confirmPassword: {
          text: t('confirmPasswordInputInfo4'),
          status: 'success',
        },
      }));
    } else {
      setMessages(prevMessages => ({
        ...prevMessages,
        confirmPassword: {
          text: t('confirmPasswordInputInfo5'),
          status: 'error',
        },
      }));
    }
  }

  // 기존 비밀번호 검증
  if (name === 'password') {
    if (value === form.password) {
      setMessages(prevMessages => ({
        ...prevMessages,
        newPassword: {
          text: t('newPasswordInputInfo5'),
          status: 'error',
        },
      }));
    }
  }
};
